<nz-layout>
  <nz-content>
    <ng-container>
      <app-reusable-table title="Nutrition Intake" [columns]="[
            'Date & Time',
            'Food Type',
            'Portion Size (gr)',
            'Portion Eaten (%)',
            'Description'
          ]" [rowFields]="[
            'onSetDateTime',
            'display',
            'portionSize',
            'portionEatenPercentage',
            'description'
          ]" [data]="nutritionIntake" [addComponent]="addComp" [deleteFun]="deleteFun" [isLoading]="isLoading"
        [openModalFun]="openModalFun" [isPreview]="false" [addPermissions]="['a-food']" />
    </ng-container>
  </nz-content>
</nz-layout>